/**
 * One login for the platform and webmail.
 *
 * Manage, Hub, Mail, Site and webmail share `bafe_session`. Mailbox grants
 * still decide who can open an inbox. Platform ownership is a separate check.
 * Older per-surface cookies are accepted until the next sign-in, then cleared.
 */

export const APP_SURFACES = ["manage", "mail", "dash"] as const;
export type AppSurface = (typeof APP_SURFACES)[number];

export const SURFACE_HEADER = "x-bafe-surface";

export const PLATFORM_SESSION_COOKIE = "bafe_session";
export const PLATFORM_CSRF_COOKIE = "bafe_csrf";

export function sessionCookieName(_surface: AppSurface): string {
	return PLATFORM_SESSION_COOKIE;
}

export function csrfCookieName(_surface: AppSurface): string {
	return PLATFORM_CSRF_COOKIE;
}

export function legacySessionCookieName(surface: AppSurface): string {
	return `bafe_session_${surface}`;
}

export function legacyCsrfCookieName(surface: AppSurface): string {
	return `bafe_csrf_${surface}`;
}

export function isAppSurface(value: string | null | undefined): value is AppSurface {
	return value === "manage" || value === "mail" || value === "dash";
}
